import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Section } from 'components/general-styles/General'
import { Grid, Col } from 'components/grid'
import { VideoPlayer } from 'src/presentation/components/video-player'

import * as S from './styles'

const HowProtectVideo: FC = memo(() => (
  <>
    <Section $bg="contrast">
      <Grid col={{ phone: 1, tablet: 1, desktop: 12 }} gap={{ phone: 'md', tablet: 'md', desktop: 'md' }}>
        <Col col={{ desktop: 4 }} start={{ desktop: 2 }}>
          <S.Title>
            <Text as="h2" size="heading3" color="var(--colors-primary-text-strong)" weight="medium">
              Veja como {' '}
              <br />
              você pode se{' '}
              <Text as="span" size="heading3" color="var(--colors-pink-text-contrast)" weight="medium">
                proteger
              </Text>
            </Text>
          </S.Title>
        </Col>
        <Col col={{ desktop: 5 }} start={{ desktop: 7 }}>
          <S.Video>
            <VideoPlayer
              videoUrl="https://www.youtube-nocookie.com/embed/Wf3ehe_d8oc?controls=0&autoplay=1"
              videoTitle="Golpes financeiros: saiba como se proteger"
              width={600}
              height={338}
              imagePlaceholder={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/security-fraud/security-fraud-video.webp`}
              alt="Mulher da Cashme explicando como se proteger de golpes financeiros"
            />
          </S.Video>
        </Col>
      </Grid>
    </Section>
  </>
))

HowProtectVideo.displayName = 'HowProtectVideo'

export default HowProtectVideo
